module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("Sword of the Lamb")])])]), _vm._v(" "), _c('h3', [_vm._v("\n\tBook One of "), _c('em', [_vm._v("The Phoenix Legacy")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("M.​K. Wren")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-645988f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/003title.vue
// module id = 60
// module chunks = 0